import React, { Children } from 'react';
import * as S from './styles';

type Props = {
  children?: React.ReactNode;
  className?: string;
  offers?: React.ReactNode[] | null;
  isExtraWide?: boolean;
  isOffers?: boolean;
};

export const OffersGrid = ({
  children,
  className,
  offers,
  isExtraWide,
  isOffers,
}: Props) => {
  return (
    <S.OffersGrid
      data-test={isOffers ? 'OfferGrid' : 'ProductGrid'}
      className={className}
      isExtraWide={isExtraWide}
    >
      {children}
      {offers &&
        Children.map(offers, (child, index) => (
          <S.OffersGridItem
            data-test={isOffers ? 'OfferGridCard' : 'ProductGridCard'}
            style={{ order: index }}
          >
            {child}
          </S.OffersGridItem>
        ))}
    </S.OffersGrid>
  );
};
